import { produce } from 'immer';
import { EXCHANGE_SOURCE } from './types.js';

export const INITIAL_STATE = {
    inProgress: false
};

export const exchangeSourceReducer = produce((draft, action) => {
    switch (action.type) {
        case EXCHANGE_SOURCE.STARTED:
            draft.inProgress = true;
            break;
        case EXCHANGE_SOURCE.REJECTED:
        case EXCHANGE_SOURCE.FAILED:
            break;
        case EXCHANGE_SOURCE.ENDED:
            draft.inProgress = false;
            break;
        default:
    }
}, INITIAL_STATE);
